import React, { useState, useRef, useEffect } from 'react';

// options: [{ value, label }]. onSelect(value, label) - apelat cand se alege o optiune
// existenta. onTextChange(text) - apelat la fiecare tastare, ca parintele sa poata
// detecta text care nu se potriveste cu nicio optiune (ex: furnizor sau material nou).
// allowFree=true - camp folosit si pentru a introduce text liber, care va deveni o
// intrare noua (ex: material nou la Intrare) - NU se goleste la iesirea din camp,
// spre deosebire de comportamentul implicit (vezi handleBlur mai jos).
export default function Combobox({ options, value, placeholder, onSelect, onTextChange, disabled, allowFree }) {
  const [text, setText] = useState('');
  const [deschis, setDeschis] = useState(false);
  const ref = useRef(null);
  // Optiunile schimba identitate la fiecare randare (parintele face .map() din nou) -
  // daca le-am pune in dependinte, efectul ar rula la fiecare tastare si ar suprascrie
  // exact ce tocmai a scris utilizatorul. Le tinem intr-un ref, actualizat mereu, dar
  // FARA sa declanseze efectul.
  const optionsRef = useRef(options);
  optionsRef.current = options;

  useEffect(() => {
    const opt = optionsRef.current.find(o => String(o.value) === String(value));
    if (opt) { setText(opt.label); return; }
    setText(allowFree && value != null && value !== '' ? String(value) : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setDeschis(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filtrate = text
    ? options.filter(o => o.label.toLowerCase().includes(text.toLowerCase()))
    : options;

  function handleChange(e) {
    const val = e.target.value;
    setText(val);
    setDeschis(true);
    if (onTextChange) onTextChange(val);
  }

  function selecteaza(opt) {
    setText(opt.label);
    setDeschis(false);
    onSelect(opt.value, opt.label);
  }

  // Daca utilizatorul tasteaza ceva si iese din camp FARA sa aleaga efectiv o
  // optiune din lista (doar click pe o alta zona a paginii), textul ramas nu
  // corespunde cu nicio valoare reala - fara asta, campul arata ca fiind completat
  // cand de fapt valoarea selectata e goala. Revenim la eticheta valorii curente
  // (sau golim, daca nu exista una) - DAR NU si atunci cand campul permite text
  // liber (allowFree): acolo textul tastat E raspunsul, nu o eroare de completat.
  function handleBlur() {
    if (allowFree) { setDeschis(false); return; }
    setTimeout(() => {
      const opt = optionsRef.current.find(o => String(o.value) === String(value));
      setText(opt ? opt.label : '');
    }, 150);
  }

  return (
    <div className="combobox" ref={ref}>
      <input
        type="text"
        value={text}
        placeholder={placeholder}
        disabled={disabled}
        onChange={handleChange}
        onFocus={() => setDeschis(true)}
        onBlur={handleBlur}
        autoComplete="off"
      />
      {deschis && filtrate.length > 0 && (
        <div className="combobox-dropdown">
          {filtrate.map(o => (
            <div key={o.value} className="combobox-opt" onMouseDown={() => selecteaza(o)}>
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
